import { titleCase } from '@/helpers/stringHelpers';

/**
 * @function getUserDefaultProfileData Helper function to setup the basic user profile information to be created
 * @returns {Object} The default profile object.
 */
export const getUserDefaultProfileData = authUser => ({
  firstName: '',
  lastName: '',
  workspaceId: null,
  isActive: true,
  uid: authUser.uid,
  avatarUrl: authUser.photoURL,
  email: authUser.email,
  isEmailVerified: authUser.emailVerified,
});

/**
 * @function shapeUserDisplayName Takes in a user object and returns a displayName string.
 * @param {Object} user The user object (ideally including first and last name)
 * @returns {String} Display name for the user.
 */
export const shapeUserDisplayName = (user) => {
  let displayName = '';

  if (!user) {
    displayName = '';
  } else if (!user.firstName && !user.lastName) {
    displayName = user.email;
  } else if (user.firstName && user.lastName) {
    displayName = `${user.firstName} ${user.lastName}`;
  } else if (user.firstName && !user.lastName) {
    displayName = `${user.firstName}`;
  } else if (!user.firstName && user.lastName) {
    displayName = `${user.lastName}`;
  }

  return titleCase(displayName.toLowerCase());
};
